import { ChangeDetectorRef, Component, ElementRef, EventEmitter, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap';
import { QueueService } from '../../../../../../common/services/Queue.service';
import { ServiceService } from '../../../../../../common/services/Service.service';
import { ToastrService } from 'ngx-toastr';
import { QueueConst } from './queue.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import * as _ from 'lodash';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import { AgentModalType } from '../../../../../../components/modals/agent-modal/agent-modal.const';
import { isEmail } from '../../../../../../common/utils/validate';

@Component({
  selector: 'settings-switchboard-queue',
  templateUrl: './queue.component.html',
  styleUrls: ['./queue.component.css'],
})
export class QueueComponent extends BaseListComponent {
  @ViewChild('template') template: ElementRef;
  @ViewChild('templateAgent') templateAgent: ElementRef;
  @ViewChild('templateParam') templateParam: ElementRef;
  @ViewChild('templateAddUpdateParam') templateAddUpdateParam: ElementRef;
  @ViewChild('templateAgentQueue') templateAgentQueue: ElementRef;

  public reLoadAgent = false;
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();
  public agentModalType = AgentModalType.AGENT_IN_QUEUE;

  public modelFilter: any = {};
  public types: any = [];
  public allQueueManager: any = [];
  public allService: any = [];
  public allParam: any = [];
  public allPriority: any = [
    // {id: '', text: 'Mức ưu tiên'},
    { id: 1, text: 'Chính' },
    { id: 2, text: 'Phụ' },
  ];
  public current_queue_id: any = null;
  public is_load_data = false;
  public many_to_queue = false;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private queueService: QueueService,
    private serviceService: ServiceService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = QueueConst.displayColumns();
  }

  async ngOnInit() {
    Observable.forkJoin([this.loadQueueManager(), this.getService()]).subscribe(() => {
      this.loadData();
    });
  }

  loadQueueManager() {
    return this.queueService.allQueueManager().map(rs => {
      const managerList = [];
      rs.data.forEach((c: any) => {
        managerList.push({
          text: c.DESCRIPTION,
          id: c.QUEUE_MANAGER_ID.toString(),
        });
      });
      this.allQueueManager = [{ text: 'Hàng đợi quản lý', id: '' }, ...managerList];
    });
  }

  getService() {
    return this.serviceService.allService().map(rs => {
      const serviceList = [];
      rs.data.forEach((c: any) => {
        serviceList.push({
          text: c.name,
          id: c.id.toString(),
        });
      });
      this.allService = [{ text: 'Dịch vụ', id: '-1' }, ...serviceList];
    });
  }

  async loadParam(queue_id) {
    this.queueService.allParam({ queue_id: queue_id }).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.allParam = res.data;
      } else {
        this.allParam = [];
      }
    });
  }

  async loadData(request: any = {}, sort: any = {}) {
    this.data = [];
    this.model = {};
    const payload = await this.buildBasePayload(request, sort);
    this.queueService
      .list(payload)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && !res.error) {
            this.data = res.data.queues;
            this.data.map(res => {
              res.display_name = QueueConst.displayNameColumns(res);
              return res;
            });
            this.initPage(res.data.total);
          } else {
            this.throwError();
          }
        },
        err => this.throwError
      );
  }

  async search() {
    this.currentPage = 1;
    let objFind = {};
    let check = false;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      objFind = { description: this.modelFilter.keyword.trim() };
      check = true;
    }
    if (this.modelFilter.service_id) {
      objFind['service_id'] = this.modelFilter.service_id;
      check = true;
    }
    if (check) {
      await this.loadData(objFind);
    } else {
      await this.loadData();
    }
  }

  ////

  async setUpModel(type, service) {
    this.typeModal = type;
    switch (service) {
      case 'queue':
        this.modelContent = {
          type: ModalType.Primary,
          title: this.typeModal === 'add' ? 'Thêm mới hàng đợi' : 'Cập nhật hàng đợi',
          submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
        };
        this.modelDisplay = [
          {
            key: 'DESCRIPTION',
            label: 'Tên hàng đợi',
            type: FormFieldType.Text,
            value: this.model.DESCRIPTION,
            required: true,
            disabled: false,
            width: 'full',
            order: 0,
          },
          {
            key: 'QUEUE_MANAGER_ID',
            label: 'Hàng đợi quản lý',
            type: FormFieldType.Select2,
            value: this.model.QUEUE_MANAGER_ID,
            required: true,
            disabled: false,
            width: 'full',
            order: 1,
            options: {
              data: this.allQueueManager,
              select2Options: {
                placeholder: { id: '', text: 'Hàng đợi quản lý' },
                value: this.model.QUEUE_MANAGER_ID,
              },
            },
          },
          {
            key: 'SERVICE_ID',
            label: 'Dịch vụ',
            type: FormFieldType.Select2,
            value: this.model.SERVICE_ID,
            required: false,
            disabled: false,
            width: 'full',
            order: 2,
            options: {
              data: this.allService,
              select2Options: {
                placeholder: { id: '', text: 'Dịch vụ' },
              },
            },
          },
        ];
        break;
      case 'addParams':
        this.modelContent = {
          type: ModalType.Primary,
          title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
          submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
        };
        this.modelDisplay = [
          {
            key: 'VALUE',
            label: 'Giá trị',
            type: FormFieldType.Text,
            value: this.model.VALUE,
            required: false,
            disabled: false,
            width: 'full',
            order: 0,
          },
        ];
        break;
      case 'queueAgent':
        this.modelContent = {
          type: ModalType.Primary,
          title: this.typeModal === 'add' ? 'Thêm chuyên viên vào hàng đợi' : 'Cập nhật',
          submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
        };
        this.modelDisplay = [
          {
            key: 'PRIORITY',
            label: 'Mức ưu tiên',
            type: FormFieldType.Select2,
            value: this.model.PRIORITY,
            required: false,
            disabled: false,
            width: 'full',
            order: 0,
            options: {
              data: this.allPriority,
              select2Options: {
                placeholder: { id: '', text: 'Mức ưu tiên' },
              },
            },
          },
        ];
        break;
    }
  }

  //////

  async addParam(queue_id, payload) {
    this.queueService.addParam(queue_id, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Lưu thành công!');
          this.loadParam(queue_id);
          this.closeModal(1);
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async add(payload) {
    this.queueService.create(payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async edit(id, payload) {
    this.queueService.update(id, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Cập nhật thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async openConfirmDelete() {
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      await this.submitDelete();
    }
  }

  async submitDelete() {
    this.queueService._delete(this.delete_id).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Xóa thành công!');
          this.loadData();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }
  async reloadAgent() {
    this.reLoadAgent = true;
    setTimeout(() => {
      this.reLoadAgent = false;
    }, 2000);
  }
  async addAgentIntoQueue(id, payload) {
    this.queueService.addAgent(id, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Thêm vào hàng đợi thành công!');
          this.closeModal(1);
          this.reloadAgent();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async addAgentIntoQueues(id, payload) {
    this.queueService.addManyAgents(id, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Thêm vào hàng đợi thành công!');
          this.closeAddAgent();
          this.reloadAgent();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }
  async closeAddAgent() {
    this.many_to_queue = false;
    this.closeModal(1);
  }

  async deleteOutQueue(id, payload) {
    this.queueService.deleteAgent(id, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Xóa khỏi hàng đợi thành công!');
          this.reloadAgent();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async deleteOutQueues(id, payload) {
    this.queueService.deleteManyAgents(id, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Xóa khỏi hàng đợi thành công!');
          this.reloadAgent();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async openConfirmDeleteOutQueue() {
    const y = confirm('Bạn có muốn xóa chuyên viên này khỏi hàng đợi không?');
    if (y) {
      await this.deleteOutQueue(this.current_queue_id, this.model.agent_id);
    }
  }

  async openConfirmDeleteOutQueues() {
    const y = confirm('Bạn có muốn các xóa chuyên viên này khỏi hàng đợi không?');
    if (y) {
      await this.deleteOutQueues(this.current_queue_id, {
        agent_ids: this.model.agent_ids,
      });
    }
  }

  //////

  public changeServiceFilter(e: any): void {
    if (!this.is_load_data) {
      let value = e.value;
      if (value === '-1' || value === 'Chọn dịch vụ' || value === 'Chọn') value = '';
      this.modelFilter.service_id = value;
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  async handleAction(type: any, item?: any) {
    this.current_queue_id = item ? item.QUEUE_ID : null;
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    switch (type) {
      case TableAction.add:
        await this.setUpModel('add', 'queue');
        this.openModal(this.template, config, null, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.edit:
        Object.keys(item).forEach(key => {
          if (item[key] !== null && item[key] !== undefined) {
            this.model[key] = item[key];
          }
        });
        this.model.QUEUE_MANAGER_ID = this.model.QUEUE_MANAGER_ID.toString();
        await this.setUpModel('edit', 'queue');
        this.openModal(this.template, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });

        break;
      case TableAction.user:
        config.class = 'modal-xxl';
        this.modelContent.title = 'Gán chuyên viên vào hàng đợi';
        this.openModal(this.templateAgent, config);
        break;
      case TableAction.params:
        config.class = 'modal-lg';
        await this.loadParam(this.current_queue_id);
        this.openModal(this.templateParam, config, null, {});
        break;
      case TableAction.delete:
        this.delete_id = item.QUEUE_ID;
        await this.openConfirmDelete();
        break;
    }
  }

  async handleSubmit(service, item?: any) {
    this.model = _.merge({}, this.model, item);
    let payload = {};
    switch (service) {
      case 'queue':
        payload = {
          DESCRIPTION: this.model.DESCRIPTION,
          QUEUE_MANAGER_ID: this.model.QUEUE_MANAGER_ID,
          SERVICE_ID: this.model.SERVICE_ID,
        };
        if (this.typeModal === 'add') {
          await this.add(payload);
        } else if (this.typeModal === 'edit') {
          await this.edit(this.model.QUEUE_ID, payload);
        }
        break;
      case 'addParams':
        payload = {
          PARAM_ID: this.model.PARAM_ID,
          VALUE: this.model.VALUE,
          DESCRIPTION: this.model.PARAM_DESC,
        };
        await this.addParam(this.current_queue_id, payload);
        break;
      case 'queueAgent':
        if (!this.many_to_queue) {
          payload = {
            AGENT_ID: this.model.agent_id,
            PRIORITY: Number(this.model.PRIORITY),
          };
          await this.addAgentIntoQueue(this.current_queue_id, payload);
        } else {
          payload = {
            agent_ids: this.model.agent_ids,
            PRIORITY: Number(this.model.PRIORITY),
          };
          await this.addAgentIntoQueues(this.current_queue_id, payload);
        }
        break;
    }
  }

  async handleActionAgent(type: any, item?: any) {
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    switch (type) {
      case 'add':
        this.model.agent_id = item.agent_id;
        this.model.PRIORITY = 1;
        await this.setUpModel('add', 'queueAgent');
        this.openModal(
          this.templateAgentQueue,
          config,
          this.model,
          {
            modelContent: this.modelContent,
            modelDisplay: this.modelDisplay,
          },
          1
        );
        break;
      case 'edit':
        this.model.agent_id = item.agent_id;
        this.model.PRIORITY = item.priority;
        await this.setUpModel('edit', 'queueAgent');
        this.openModal(
          this.templateAgentQueue,
          config,
          this.model,
          {
            modelContent: this.modelContent,
            modelDisplay: this.modelDisplay,
          },
          1
        );
        break;
      case 'delete':
        this.model.agent_id = item.agent_id;
        await this.openConfirmDeleteOutQueue();
        break;
      case 'addAll':
        this.model.agent_ids = item;
        this.model.PRIORITY = 1;
        this.many_to_queue = true;
        await this.setUpModel('add', 'queueAgent');
        this.openModal(
          this.templateAgentQueue,
          config,
          this.model,
          {
            modelContent: this.modelContent,
            modelDisplay: this.modelDisplay,
          },
          1
        );
        break;
      case 'deleteAll':
        this.model.agent_ids = item;
        await this.openConfirmDeleteOutQueues();
        break;
    }
  }

  async handleActionParams(type: any, item?: any) {
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    if (type === 'add') {
      this.model = {
        PARAM_ID: item.PARAM_ID,
        VALUE: '',
        DESCRIPTION: item.PARAM_DESC,
      };
      await this.setUpModel('add', 'addParams');
    } else {
      this.model = {
        PARAM_ID: item.PARAM_ID,
        VALUE: item.VALUE,
        DESCRIPTION: item.PARAM_DESC,
      };
      await this.setUpModel('edit', 'addParams');
    }
    this.openModal(
      this.templateAddUpdateParam,
      config,
      this.model,
      {
        modelContent: this.modelContent,
        modelDisplay: this.modelDisplay,
      },
      1
    );
  }
  async onChangeValueModel(service, key, item?: any) {
    this.model = _.merge({}, this.model, item);
    this.message = null;
    await this.setUpModel(this.typeModal, service);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/queue/queue.component.ts